import { useEffect } from "react";
import LandingPage from "./LandingPage";
import HomePage from "./HomePage";
import Dashboard from "./Dashboard";
import AboutUs from "./AboutUs";
import Editor from "./Editor";
import ErrorBoundary from "./components/ErrorBoundary";
import { supabase } from "./lib/supabaseClient";

function App() {
  // Simple route check for MVP
  const isDashboard = window.location.pathname === '/dashboard';
  const isAbout = window.location.pathname === '/about';
  const isEditor = window.location.pathname.startsWith('/editor');
  const isHome = window.location.pathname === '/home';
  
  useEffect(() => {
    // Test database connection with error handling
    try {
      supabase.from("books").select("*").then(console.log).catch(error => {
        console.warn('⚠️ [APP] Database connection failed, but continuing:', error);
      });
    } catch (error) {
      console.warn('⚠️ [APP] Database initialization failed, but continuing:', error);
    }
  }, []);
  
  return (
    <ErrorBoundary>
      {isDashboard ? <Dashboard /> : isAbout ? <AboutUs /> : isEditor ? <Editor /> : isHome ? <HomePage /> : <LandingPage />}
    </ErrorBoundary>
  );
}

export default App; 